module.exports = __webpack_public_path__ + "static/media/fivek-fr.1a66fd01.png";